export default __webpack_public_path__ + "static/media/bin.61579e5c.svg";